
import { computed, defineComponent } from "vue";
import store from "@/stores";
import Thumbnail, {
  ThumbnailItem,
} from "@/components/ThumbnailOptionSample.vue";
import { toResourceUrl } from "@/lib/shared";

export interface IOptiondialogData {
  title: string;
  message: string;
  imagesNo: number;
  thumbanil: ThumbnailItem;
}

const optionImages: IOptiondialogData[] = [
  {
    title: "有名漫画家のみ",
    message: "",
    imagesNo: 350,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "画像配置エリアあり",
    message: "※製品写真やロゴを配置できる領域が含まれています。",
    imagesNo: 368,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "効果音のあるコマのみ",
    message: "",
    imagesNo: 18,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "屋内シーンあり",
    message: "※背景に屋内の風景が描かれています。",
    imagesNo: 180,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "カラーのみ",
    message: "",
    imagesNo: 202,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "説明ボードあり",
    message:
      "※ボードや看板など文字や商品を強調表示できる絵が　　　　　　　含まれます。",
    imagesNo: 494,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "1コマに複数人登場",
    message: "",
    imagesNo: 896,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "野外シーンあり",
    message: "※背景に屋外の風景が描かれています。",
    imagesNo: 524,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "モノクロのみ",
    message: "",
    imagesNo: 316,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "バナー広告向け",
    message: "※バナー広告に適したコマが含まれます。",
    imagesNo: 171,
    thumbanil: ThumbnailItem.Empty(),
  },
  {
    title: "指さしコマあり",
    message: "",
    imagesNo: 128,
    thumbanil: ThumbnailItem.Empty(),
  },
];

export default defineComponent({
  name: "Optiondialog",
  components: {
    Thumbnail,
  },
  props: {
    isShowModal: { type: Boolean },
  },
  setup(props, context) {
    const resource = store.useResource();

    const isShowModalInner = computed({
      get: () => props.isShowModal,
      set: (newValue) => {
        context.emit("update:isShowModal", newValue);
      },
    });

    const templates = resource.data.templateSets;
    templates.forEach((el) => {
      optionImages.forEach((el2) => {
        if (el.id == el2.imagesNo) {
          const thumbnailItem = new ThumbnailItem({
            imgPath: toResourceUrl(el.thumbnail ?? ""),
          });
          el2.thumbanil = thumbnailItem;
        }
      });
    });

    const close = () => {
      isShowModalInner.value = false;
    };

    return {
      optionImages,
      isShowModalInner,
      close,
    };
  },
});
